import { render, staticRenderFns } from "./Tickettoapplyfor.vue?vue&type=template&id=560df0e2&"
import script from "./Tickettoapplyfor.vue?vue&type=script&lang=js&"
export * from "./Tickettoapplyfor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports